import { useMemo } from "react";
import type { ConsentViewT } from "@/types/database/consents";
import { useConsentsByDiaryId } from "../api/selectConsentById";
import { mergeDiaryConsents } from "../utils/mergeDiaryConsents";

interface DiaryConsentsSource {
    diary_id?: string | null;
    consents_view?: ConsentViewT[] | null;
}

/** Same consent list for clinician history, patient to-dos, and journey progress. */
export function useDiaryConsents(diary?: DiaryConsentsSource | null) {
    const diaryId = diary?.diary_id ?? "";
    const query = useConsentsByDiaryId(diaryId, { enabled: Boolean(diaryId) });
    const consents = useMemo(
        () => mergeDiaryConsents(diary?.consents_view, query.data),
        [diary?.consents_view, query.data]
    );

    return { ...query, consents };
}
